module.exports = __webpack_public_path__ + "img/ic_avatar_default.6d6821bd.png";